import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sessions: [],
    sessionsLoaded: false,
    swGroupNumber: null,
    tcGroupNumber: null,
    dropDownActive: null,
    mediaStatus: {},
    mediaStatusIsLoaded: false,
    mediaStatusHasDisabled: false,
    discountCustomer: {},
    discountTempCustomer: {},
    discountActivities: {
      bj: [],
      sj: [],
      sw: [],
      tc: [],
    },
    discountLogicSettings: {},
    discountCustomerFound: false,
    customerLatestSession: {},
    nfcAssignSuccessful: false,
    popupOpen: false,
    nfcTagAlreadyAssigned: false,
    jumpOffStatus: null,
    jumpOffDescription: null,
    jumpOffReason: null,
    groupMember: [],
    groupMemberRemoved: [],
    groupCamera: [],
    groupCameraRemoved: [],
    groupErrorMessage: [],
    tandemMember: {
      customers: [],
      cameras: [],
    },
    tandemActivity: "",
    hasBJandSJ: false,
    nfcScanParams: {},
  },
  actions,
  mutations,
  getters
})